export const CHUNK_PART_SIZE = 22 * 1024; // chunk limit to avoid websocket buffer overflow (32KB)
